<template>
  <Wrapper
    bgColor="#FAFAFA"
    contentWidth="lg"
    wrapperHeight="viewport"
    v-if="estimate"
  >
    <div class="py-12">

      <h2 class="playfair-display text-4xl text-center mb-6">
        Your property's estimated rental rate is
      </h2>

      <div class="playfair-display text-5xl font-bold text-center mb-12">
        {{numeral(estimate.rent_cast_data.rentRangeLow).format('$0,0')}} - {{numeral(estimate.rent_cast_data.rentRangeHigh).format('$0,0')}}
      </div>

      <p class="text-center mb-4">
        This estimate hasn't factored in your property condition, upgrades, community amenities, etc.
      </p>

    </div>

  </Wrapper>
</template>

<script>
import numeral from 'numeral';
import Wrapper from './Wrapper.vue';

export default {
  name: 'EstimatedRent',
  components: {
    Wrapper,
  },
  computed: {},
  data() {
    return {
      estimate: window.app.estimate,
    };
  },
  methods: {
    numeral(value) {
      return numeral(value);
    }
  },
}
</script>

<style scoped lang="scss">

</style>
